import { Divider, Grid, Text } from '@wework/dieter-ui'
import LinkRoom from '../SidebarBlocks/LinkRoom'
import React from 'react'
import {
  CheckIsDedicatedDesk,
  CheckIsHotDesk,
} from '../../utils/EntitySynonyms'
import ProductType from '../SidebarBlocks/ProductType'
import EditProductAttributes from './EditProductAttributes'

export default function EditProduct({ space, roomData, setRoomData }) {
  if (!space) {
    return null
  }
  return (
    <div>
      <Grid style={{ marginTop: 24 }}>
        <Grid.Row stretched>
          <Grid.Column>
            <div>
              <Text style={{ fontWeight: 'bold', fontSize: 16 }}>
                Inventory
              </Text>
            </div>
          </Grid.Column>
        </Grid.Row>
        {!CheckIsHotDesk(space.subType.toUpperCase()) &&
          !CheckIsDedicatedDesk(space.subType.toUpperCase()) && (
            <>
              <LinkRoom space={space} />
              <Divider light style={{ width: '100%' }} />
            </>
          )}
        <ProductType
          space={space}
          setRoomData={setRoomData}
          roomData={roomData}
        />
        {space.inventoryData &&
        space.inventoryData?.relationships?.length > 0 ? (
          <div>
            <Grid>
              <Grid.Row>
                <Grid.Column style={{ paddingRight: '0' }}>
                  <Divider light style={{ width: '100%' }} />
                  <div>
                    <Text style={{ fontWeight: 'bold', fontSize: 16 }}>
                      Details
                    </Text>
                    <Text style={{ paddingBottom: '20px', fontSize: 14 }}>
                      Manage inventory by keeping the data up to date. Some
                      changes require approval.
                    </Text>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <EditProductAttributes
              space={space}
              roomData={roomData}
              setRoomData={setRoomData}
            />
          </div>
        ) : (
          <>
            <Grid>
              <Grid.Row>
                <Grid.Column style={{ paddingRight: '0' }}>
                  <div>
                    <Text style={{ fontWeight: 'bold', fontSize: 16 }}>
                      Details
                    </Text>
                    <Text
                      size="tiny"
                      style={{ backgroundColor: '#F7F7F7', padding: '16px' }}
                    >
                      ⚠️ Link inventory to this space and you’ll be able to
                      view/update the inventory information here.
                    </Text>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  )
}
